import { AvatarStack } from '@primer/react';
import * as React from 'react';
export default {
  AvatarStack,
  React
};